import { opaccAjaxPlugin } from '../opacc.static.js';
/** @module general */

/**
 * SocialMedia Plattformen um Inhalt zu teilen anbieten
 *
 */
export class OpaccSocialMedia {
	constructor() {
		this.attachEventListener();
	}

	/**
	 *
	 *
	 * @param {*} pubId
	 * @param {*} customJs
	 * @param {*} cnf
	 * @param {*} containerId
	 * @param {boolean} addthisFnc
	 */
	successFnc(pubId, customJs, cnf, containerId, addthisFnc) {
		let scriptRunner = new Function(addthisFnc);
		scriptRunner.apply();
		// eslint-disable-next-line no-undef
		addthis.toolbox(`#${containerId}`);
		// eslint-disable-next-line no-undef
		addthis.addEventListener('addthis.menu.share', evt => {
			document.dispatchEvent(new CustomEvent('opaccSocialInteractionEvent', { 'detail': { 'action': 'shared', 'tracker': 'send', 'hitType': 'social', 'socialNetwork': evt.data.service, 'socialAction': 'share', 'socialTarget': location.href } }));
		});
	}

	/**
	 *
	 *
	 * @param {*} error
	 */
	errorFnc(error) {
		// eslint-disable-next-line no-console
		console.error('Socialmedia failed: ', error);
	}

	/**
	 *
	 *
	 */
	attachEventListener() {
		document.addEventListener('DOMContentLoaded', () => {
			let elemList = document.querySelectorAll('.opc-social-media-buttons');
			Array.from(elemList).forEach(item => {
				if (item.dataset.opType == 'addthis') {
					let pubId = item.dataset.opPubid;
					let customJs = item.dataset.opCustomjs;
					let cnf = item.dataset.opConfig;
					let containerId = item.firstElementChild.id;
					let fncArg = [pubId, customJs, cnf, containerId];
					let initGet = opaccAjaxPlugin.getDefaultGetInitObj();
					initGet['dataType'] = 'script';
					initGet['cache'] = true;
					delete initGet.credentials;
					opaccAjaxPlugin.fetchAsync(`//s7.addthis.com/js/300/addthis_widget.js#pubid=${pubId}`, initGet, this.successFnc.bind(this, ...fncArg), this.errorFnc);
				}
			});
		});
	}
}